import { currencyTypes } from "@/models/general";
import Buttons from "@components/Buttons";
import classes from "@components/Header/AppBarDefault/styles.module.scss";
import { KeyboardArrowDown } from "@mui/icons-material";
import { Menu, MenuItem, Typography } from "@mui/material";
import clsx from "clsx";

interface ButtonChangeCurrency {
  anchorElCurrency: Element | (() => Element) | null | undefined | any;
  setAnchorElCurrency: (
    value: React.SetStateAction<HTMLElement | null>
  ) => void;
  handleShowCurrency: string | undefined;
  handleShowCurrencyMobile: string | undefined;
  changeCurrency: (currency: string) => Promise<void>;
  currency: string | undefined;
}

const ButtonChangeCurrency = ({
  changeCurrency,
  setAnchorElCurrency,
  handleShowCurrency,
  handleShowCurrencyMobile,
  anchorElCurrency,
  currency,
}: ButtonChangeCurrency) => {
  return (
    <div className={"hidden md:flex min-w-[95px]"}>
      <Buttons
        className={clsx(classes.btnChangeLang, "w-full")}
        padding="7px 10px"
        onClick={(e) => setAnchorElCurrency(e.currentTarget)}
        endIcon={
          currency ? (
            <KeyboardArrowDown
              sx={{
                transform: Boolean(anchorElCurrency)
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          ) : null
        }
      >
        <span className={classes.desktop}>{handleShowCurrency}</span>
        <span className={classes.mobile}>{handleShowCurrencyMobile}</span>
      </Buttons>
      <Menu
        disableScrollLock={true}
        className={"hidden md:flex"}
        anchorEl={anchorElCurrency}
        open={Boolean(anchorElCurrency)}
        onClose={() => setAnchorElCurrency(null)}
        sx={{
          "& .MuiMenuItem-root": {
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "24px",
            letterSpacing: "0%",

            "&.Mui-selected": {
              backgroundColor: "var(--cimigo-blue)  !important",
              color: "#FFFFFF !important",
              "&:hover": {
                backgroundColor: "#4A7EBD !important",
              },
            },
          },
        }}
      >
        {currencyTypes.map((it) => (
          <MenuItem
            key={it.id}
            onClick={() => changeCurrency(it.id)}
            className={clsx("", {
              [classes.active]: it.id === (currency ?? "USD"),
            })}
            selected={it.id === (currency ?? "USD")}
          >
            <Typography className={classes.itName}>{it.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ButtonChangeCurrency;
